import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  dashboard: {
    id: 'category.header.dashboard.label',
    defaultMessage: 'Dashboard',
    description: 'The text for the link to the Dashboard page.',
  },
  help: {
    id: 'category.header.help.label',
    defaultMessage: 'Help',
    description: 'The text for the link to the Help Center.',
  },
  courses: {
    id: 'category.header.course',
    defaultMessage: 'Courses',
    description: 'The text for the link to the Courses page.',
  },
  exploreCourses: {
    id: 'category.header.explore-courses',
    defaultMessage: 'Explore courses',
    description: 'The text for the link to the Explore courses page.',
  },
  programs: {
    id: 'category.header.programs',
    defaultMessage: 'Programs',
    description: 'The text for the link to the Programs page.',
  },
  discoverNew: {
    id: 'category.header.discoverNew',
    defaultMessage: 'Discover new',
    description: 'The text for the link to the Discover new page.',
  },
});

export default messages;
